import AppLink from '../AppLink';
import styles from './AppSocials.module.scss';

export default function AppSocials() {
  const facebook = 'https://www.facebook.com/101834517907650';
  const instagram = 'https://www.instagram.com/carline.auto.import';
  const youtube = 'https://www.youtube.com/';

  return (
    <ul className={styles.AppSocials}>
      <li className={styles.AppHeroSocials__Item}>
        <AppLink href={facebook}>
          <FacebookIcon />
        </AppLink>
      </li>
      <li>
        <AppLink href={instagram}>
          <InstagramIcon />
        </AppLink>
      </li>
      {/* <li>
        <AppLink href={youtube}>
          <YoutubeIcon />
        </AppLink>
      </li> */}
    </ul>
  );
}

function FacebookIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_37_9169)">
        <path
          d="M0 10.1111C0 15.1111 3.55556 19.2222 8.33333 20V12.7778H5.77778V10H8.22222V7.77778C8.22222 5.33333 9.77778 3.88889 12.1111 3.88889C12.7778 3.88889 13.6667 4 14.3333 4.11111V6.66667H13.1111C11.8889 6.66667 11.5556 7.22222 11.5556 8.11111V10H14.2222L13.7778 12.7778H11.5556V20C16.3333 19.1111 19.8889 15 19.8889 10.1111C19.8889 4.55556 15.4444 0 9.88889 0C4.33333 0 0 4.55556 0 10.1111Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_37_9169">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function InstagramIcon() {
  return (
    <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_37_9175)">
        <path
          d="M9.49922 1.93359C11.9967 1.93359 12.2898 1.94531 13.277 1.99219C14.1898 2.03516 14.6834 2.19531 15.0137 2.33203C15.4516 2.51172 15.7633 2.72266 16.0898 3.06641C16.4164 3.41016 16.6205 3.73828 16.7875 4.19922C16.9137 4.54688 17.0695 5.06641 17.1104 6.02734C17.1549 7.06641 17.166 7.375 17.166 10.0039C17.166 12.6328 17.1549 12.9414 17.1104 13.9805C17.0695 14.9414 16.9174 15.4609 16.7875 15.8086C16.6168 16.2695 16.4164 16.5977 16.0898 16.9414C15.7633 17.2852 15.4516 17.5 15.0137 17.6758C14.6834 17.8086 14.1898 17.9727 13.277 18.0156C12.2898 18.0625 11.9967 18.0742 9.49922 18.0742C7.00176 18.0742 6.70859 18.0625 5.72148 18.0156C4.80859 17.9727 4.31504 17.8125 3.98477 17.6758C3.54688 17.4961 3.23516 17.2852 2.90859 16.9414C2.58203 16.5977 2.37793 16.2695 2.21094 15.8086C2.08477 15.4609 1.92891 14.9414 1.88809 13.9805C1.84355 12.9414 1.83242 12.6328 1.83242 10.0039C1.83242 7.375 1.84355 7.06641 1.88809 6.02734C1.92891 5.06641 2.08105 4.54688 2.21094 4.19922C2.38164 3.73828 2.58203 3.41016 2.90859 3.06641C3.23516 2.72266 3.54688 2.50781 3.98477 2.33203C4.31504 2.19922 4.80859 2.03516 5.72148 1.99219C6.70859 1.94141 7.00176 1.93359 9.49922 1.93359ZM9.49922 0.160156C6.96094 0.160156 6.6418 0.171875 5.64355 0.21875C4.64902 0.265625 3.96992 0.433594 3.37617 0.675781C2.76016 0.925781 2.24063 1.26563 1.72109 1.8125C1.20156 2.35938 0.882422 2.91016 0.641211 3.55469C0.411133 4.17969 0.251562 4.89453 0.207031 5.94531C0.1625 6.99219 0.151367 7.32812 0.151367 10C0.151367 12.6719 0.1625 13.0078 0.207031 14.0586C0.251562 15.1055 0.411133 15.8203 0.641211 16.4492C0.878711 17.0977 1.20156 17.6445 1.72109 18.1914C2.24063 18.7383 2.76387 19.0742 3.37617 19.3281C3.96992 19.5703 4.64902 19.7383 5.64727 19.7852C6.64551 19.832 6.96094 19.8438 9.50293 19.8438C12.0449 19.8438 12.3604 19.832 13.3586 19.7852C14.3531 19.7383 15.0322 19.5703 15.6297 19.3281C16.2457 19.0781 16.7652 18.7383 17.2848 18.1914C17.8043 17.6445 18.1234 17.0938 18.3646 16.4492C18.5947 15.8242 18.7543 15.1094 18.7988 14.0586C18.8434 13.0078 18.8545 12.6758 18.8545 10C18.8545 7.32422 18.8434 6.99219 18.7988 5.94141C18.7543 4.89453 18.5947 4.17969 18.3646 3.55078C18.1271 2.90234 17.8043 2.35547 17.2848 1.80859C16.7652 1.26172 16.242 0.925781 15.6297 0.671875C15.0359 0.429688 14.3568 0.261719 13.3586 0.214844C12.3566 0.171875 12.0375 0.160156 9.49922 0.160156Z"
          fill="white"
        />
        <path
          d="M9.5002 4.94531C6.85059 4.94531 4.69824 7.20703 4.69824 10C4.69824 12.793 6.85059 15.0547 9.5002 15.0547C12.1498 15.0547 14.3021 12.7891 14.3021 10C14.3021 7.21094 12.1498 4.94531 9.5002 4.94531ZM9.5002 13.2812C7.77832 13.2812 6.38301 11.8125 6.38301 10C6.38301 8.1875 7.77832 6.71875 9.5002 6.71875C11.2221 6.71875 12.6174 8.1875 12.6174 10C12.6174 11.8125 11.2221 13.2812 9.5002 13.2812Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_37_9175">
          <rect width="19" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function YoutubeIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.541 5.20087C19.3113 4.34771 18.6386 3.67503 17.7855 3.44533C16.2268 3.03516 9.99218 3.03516 9.99218 3.03516C9.99218 3.03516 3.75757 3.03516 2.19891 3.44533C1.34575 3.67503 0.673072 4.34771 0.443375 5.20087C0.0332031 6.75952 0.0332031 9.99168 0.0332031 9.99168C0.0332031 9.99168 0.0332031 13.2402 0.443375 14.7825C0.673072 15.6356 1.34575 16.3083 2.19891 16.538C3.75757 16.9482 9.99218 16.9482 9.99218 16.9482C9.99218 16.9482 16.2268 16.9482 17.7855 16.538C18.6386 16.3083 19.3113 15.6356 19.541 14.7825C19.9512 13.2238 19.9512 9.99168 19.9512 9.99168C19.9512 9.99168 19.9676 6.75952 19.541 5.20087ZM8.00695 12.9941V7.00562L13.1915 9.99168L8.00695 12.9941Z"
        fill="white"
      />
    </svg>
  );
}
